export default "__VITE_ASSET__6a757edb__"